export type RequestGuard = {
    next: () => number;
    isLatest: (id: number) => boolean;
};

export function createRequestGuard(): RequestGuard {
    let latestId = 0;

    return {
        next: () => {
            latestId += 1;
            return latestId;
        },
        isLatest: (id: number) => id === latestId,
    };
}

/** Initial loading for page-level list stores that render a skeleton on mount. */
export const PAGE_LIST_LOADING_INITIAL = true;
